const TableHeaderRow = ({ children, className }) => {
  return <header className={`${className} w-full bg-slate-200`}>{children}</header>
}

export default TableHeaderRow
